import {extend} from 'flarum/extend';
import TagLinkButton from 'flarum/tags/components/TagLinkButton';
import DiscussionHero from 'flarum/components/DiscussionHero';
import extract from 'flarum/utils/extract';
import sortTags from 'flarum/tags/utils/sortTags';
import tagIcon from 'flarum/tags/helpers/tagIcon';

export default () => {
  extend(TagLinkButton.prototype, 'view', function (vnode) {
    vnode.attrs.title = "";
  });

  extend(DiscussionHero.prototype, 'view', function (vnode) {
    vnode.attrs.title = "";
  });

  // Add a list of a discussion's tags to the discussion hero, displayed
  // before the title. Put the title on its own line.
  extend(DiscussionHero.prototype, 'items', function(items) {
    const tags = this.attrs.discussion.tags();

    if (tags && tags.length) {
      items.add('tags', tagsLabel(tags, {link: true}), 5);
    }
  });
}

function tagsLabel(tags, attrs = {}) {
  const children = [];
  const link = extract(attrs, 'link');

  attrs.className = `TagsLabel ${(attrs.className || '')}`;

  if (tags) {
    sortTags(tags).forEach(tag => {
      if (tag || tags.length === 1) {
        children.push(tagLabel(tag, {link}));
      }
    });
  } else {
    children.push(tagLabel());
  }

  return <span {...attrs}>{children}</span>;
}

function tagLabel(tag, attrs = {}) {
  attrs.style = attrs.style || {};
  attrs.className = `TagLabel ${(attrs.className || '')}`;

  const link = extract(attrs, 'link');
  const tagText = tag ? tag.name() : app.translator.trans('flarum-tags.lib.deleted_tag_text');

  if (tag) {
    const color = tag.color();
    if (color) {
      attrs.style.backgroundColor = attrs.style.color = color;
      attrs.className += ' colored';
    }

    if (link) {
      attrs.href = app.route('tag', {tags: tag.slug()});
    }
  } else {
    attrs.className += ' untagged';
  }

  return (
    m((link ? 'a' : 'span'), attrs,
      <span className="TagLabel-text">
      {tag && tag.icon() && tagIcon(tag, {}, {useColor: false})} {tagText}
    </span>
    )
  );
}
